import { LinkIcon } from '@heroicons/react/24/outline'
import { useCallback, useState } from 'react'

import { IconButton } from './IconButton'

interface CopyButtonProps {
  /**
   * The text to copy to clipboard
   */
  textToCopy: string
  /**
   * Optional custom label. Defaults to "Copy Link"
   */
  label?: string
  /**
   * Optional custom className
   */
  className?: string
}

/**
 * A reusable button component that copies text to clipboard.
 * Shows visual feedback when text is copied successfully.
 */
export const CopyButton = ({
  textToCopy,
  label = 'Copy Link',
  className = 'btn-link text-info',
}: CopyButtonProps) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(textToCopy)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 2000)
  }, [textToCopy])

  return (
    <IconButton
      className={className}
      icon={LinkIcon}
      onClick={handleCopy}
      title={isCopied ? 'Copied!' : 'Copy to clipboard'}
    >
      {isCopied ? 'Copied!' : label}
    </IconButton>
  )
}
